// Coarse Jira environment label for the page's <meta name="jira-env">: 'sandbox'
// or 'prod' ONLY — never the raw host, so the sandbox domain is not exposed in
// the page source. Derived from the backend browse base (built from JSM_DOMAIN);
// the sandbox browse base is the only one containing "sandbox".
export const jiraEnvLabel = (browseBase?: string | null): 'sandbox' | 'prod' =>
  browseBase && /sandbox/i.test(browseBase) ? 'sandbox' : 'prod';

// Reflect the active Jira env in a <meta name="jira-env"> tag ('sandbox' | 'prod')
// so a developer can confirm it from the page source. Creates the tag if missing.
export const setJiraEnvMeta = (browseBase?: string | null): void => {
  if (typeof document === 'undefined') return;
  let meta = document.querySelector('meta[name="jira-env"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'jira-env');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', jiraEnvLabel(browseBase));
};
